import { get } from "lodash";

import { iconTransformsInitialState } from "./state";

export const setEditorPreview = ({ state, iconId, editorPreviewHtml }) => {
    const svgDataUri = `data:image/svg+xml;base64,${btoa(
        unescape(encodeURIComponent(editorPreviewHtml))
    )}`;

    const currentIconTransformsState = state[iconId];

    const newIconTransformsState = {
        ...(currentIconTransformsState || iconTransformsInitialState),
        editorPreview: svgDataUri
    };

    return {
        ...state,
        [iconId]: { ...newIconTransformsState }
    };
};

const rotateClockwise = ({ currentRotation }) => {
    if (currentRotation === 345) return 0;
    return currentRotation + 15;
};

const rotateCounterclockwise = ({ currentRotation }) => {
    if (currentRotation === 0) return 345;
    return currentRotation - 15;
};

export const rotate = ({ state, iconId, direction }) => {
    const currentRotation = get(
        state,
        [iconId, "rotation"],
        iconTransformsInitialState.rotation
    );

    let newRotation;

    if (direction === "cw")
        newRotation = rotateClockwise({
            currentRotation
        });

    if (direction === "ccw")
        newRotation = rotateCounterclockwise({
            currentRotation
        });

    const currentIconTransformsState = state[iconId];

    const newIconTransformsState = {
        ...(currentIconTransformsState || iconTransformsInitialState),
        rotation: newRotation
    };

    return {
        ...state,
        [iconId]: { ...newIconTransformsState }
    };
};

export const flip = ({ state, axis, iconId }) => {
    let key;

    if (axis === "x") key = "flipX";
    if (axis === "y") key = "flipY";

    const currentIconTransformsState = state[iconId];

    const newIconTransformsState = {
        ...(currentIconTransformsState || iconTransformsInitialState),
        [key]: !get(state, [iconId, key], iconTransformsInitialState[key])
    };

    return {
        ...state,
        [iconId]: { ...newIconTransformsState }
    };
};

export const addToRecentColors = ({ isBackgroundColor, colorToAdd, state }) => {
    const key = isBackgroundColor ? "backgroundColors" : "iconColors";

    const recentColors = [...state[key].recent];
    const notInRecentColors = recentColors.indexOf(colorToAdd) === -1;
    const RECENT_COLORS_MAX_LENGTH = 10;

    if (recentColors.length === RECENT_COLORS_MAX_LENGTH && notInRecentColors) {
        recentColors.pop();
    }

    return {
        ...state,
        [key]: {
            ...state[key],
            recent: [
                colorToAdd,
                ...recentColors.filter(color => color !== colorToAdd)
            ]
        }
    };
};
